export default [
  {
    name: 'Bride and Groom\'s Name',
    type: 'dynamic-select',
    dataUrl: 'destination-weddings/all',
    dataField: 'name',
    options: [],
    value: '',
    slug: 'wedding',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'Room Category',
    type: 'text',
    value: '',
    slug: 'room-category',
    classes: 'half',
    required: false,
    show: true
  },
  {
    name: 'Number of Rooms',
    type: 'number',
    value: '',
    slug: 'number-of-rooms',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'Number of Guests',
    type: 'number',
    value: 1,
    min: 1,
    max: 7,
    slug: 'number-of-guests',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'Arrival Date',
    type: 'datepicker',
    value: '',
    slug: 'arrival-date',
    initialView: 'month',
    classes: 'half',
    required: true,
    show: true,
    initialView: 'day'
  },
  {
    name: 'Departure Date',
    type: 'datepicker',
    value: '',
    slug: 'departure-date',
    initialView: 'month',
    classes: 'half',
    required: true,
    show: true,
    initialView: 'day'
  },
  {
    name: 'Include Air Transportation?',
    type: 'radio',
    options: [
      'Yes',
      'No'
    ],
    value: '',
    slug: 'include-air-transportation',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'What city will you be flying from?',
    type: 'text',
    value: '',
    slug: 'departure-city',
    classes: 'half',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'include-air-transportation',
        values: ['Yes']
      }
    ],
    show: false
  },
  {
    name: 'Transfer Options',
    type: 'select',
    options: [
      {
        value: 'Will arrange myself',
        name: 'Will arrange myself'
      },
      {
        value: 'Private Van Transfer (1-6)',
        name: 'Private Van Transfer (1-6)'
      },
      {
        value: 'Private Shuttle Transfer',
        name: 'Private Shuttle Transfer'
      }
    ],
    value: '',
    slug: 'departure-city',
    classes: 'half',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'include-air-transportation',
        values: ['Yes']
      }
    ],
    show: false
  },
  {
    name: 'Daytime Phone',
    type: 'text',
    value: '',
    slug: 'daytime-phone',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'Evening Phone',
    type: 'text',
    value: '',
    slug: 'evening-phone',
    classes: 'half',
    required: true,
    show: true
  },
  {
    name: 'Address',
    type: 'textarea',
    value: '',
    slug: 'address',
    classes: 'full',
    required: true,
    show: true
  },
  {
    name: 'Traveler Details',
    type: 'form-section',
    value: '',
    slug: '',
    required: false,
    description: 'IMPORTANT NOTE: TSA requires your full name, exactly as it appears on your passport. If you are not sure, please double check your passport so the information provided is correct. If you have not applied for your passport yet, please provide your full name as it will be requested on your passport application. If the traveler does not have a middle name, please type "NMN" (No Middle Name).',
    conditions: [
      {
        operator: '!=',
        field: 'payment-type',
        values: ['Wedding Registry Payment', 'Incremental/Final Payment']
      }
    ],
    show: true
  },
  {
    name: 'Traveler Information',
    type: 'numeric-repeater',
    numberField: 'number-of-guests',
    subFields: [],
    classes: 'full',
    slug: 'traveler-information',
    required: false,
    subFieldTemplate: [
      {
        name: 'First Name',
        type: 'text',
        value: '',
        slug: 'first-name',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Middle Name',
        type: 'text',
        value: '',
        slug: 'middle-name',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Last Name',
        type: 'text',
        value: '',
        slug: 'last-name',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Date Of Birth',
        type: 'datepicker',
        value: '',
        slug: 'date-of-birth',
        classes: 'fifth',
        required: true
      },
      {
        name: 'Email',
        type: 'text',
        value: '',
        slug: 'email',
        classes: 'fifth',
        required: false
      }
    ],
    show: true
  },
  {
    name: 'Travel Protection Insurance',
    type: 'form-section',
    value: '',
    slug: '',
    required: false,
    description: 'Travel insurance is highly recommended and we offer several options, including coverage for pre-existing conditions and "cancel for any reason" (if available). Please ask your travel advisor for details. If insurance is declined, the package price will be non-refundable even in the case of weather issues, flight cancellations or travel interruptions. Please note that many health insurance policies, including Medicare, do not provide coverage outside of the United States. Furthermore, travel protection and assistance provided by your credit card company may be very limited.',
    show: true
  },
  {
    name: 'Travel Protection Option',
    type: 'radio',
    value: '',
    slug: 'travel-protection-option',
    classes: 'full',
    options: [
      'Yes, I would like information about purchasing travel protection at an additional cost',
      'No, I decline travel protection and understand I will be responsible for any change or cancellation penalties'
    ],
    required: true,
    show: true
  },
  {
    name: 'By selecting this option, I understand that I am responsible for ensuring I have adequate coverage for trip cancellation and/or interruption and that I am responsible any uncovered losses.',
    type: 'toggle',
    value: false,
    slug: 'travel-protection-understood',
    classes: 'full',
    required: true,
    conditions: [
      {
        operator: '==',
        field: 'travel-protection-option',
        values: ['No, I decline travel protection and understand I will be responsible for any change or cancellation penalties']
      }
    ],
    show: true
  },
  {
    name: 'Special Request or Message To Travel Advisor',
    type: 'textarea',
    value: '',
    slug: 'special-message-to-travel-advisor',
    classes: 'full',
    required: false,
    show: true
  }
];